import React, { useState, useEffect, useRef} from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import api from '../../service/api';
import EtapaFonteAusente from './EtapaFonteAusente';
import '../../css/AvaliacaoNeuromuscular.css';
import '../../css/style.css';
import { HelpCircle, Info } from "lucide-react";
import Indicador from '../../images/indicador.png';
import IconAgachamento from '../../images/powerlifting.png';
import IconMusculo from '../../images/muscle.png';
import { formatarNumero } from '../../utils/formato';

import { faixasPreensaoManual, calcularResultadoPreensao, descreverAssimetria, textoClassificacaoPreensao, PROTOCOLO_PREENSAO_MANUAL } from '../../utils/preensaoManual';
function AvaliacaoNeuromuscular({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
  // Navegação entre etapas
  const [etapa, setEtapa] = useState(1);
  const totalEtapas = 3;
  const porcentagemConclusao = (etapa / totalEtapas) * 100;

  const avancarEtapa = () => {
    setEtapa(etapa + 1);
  };

  // Testes de opção única não têm a etapa intermediária de escolha do método.
  const TESTES_SEM_ETAPA_INTERMEDIARIA = ['ForcaRelativa', 'ApreensaoManual'];

  const retrocederEtapa = () => {
    if (etapa === 3 && TESTES_SEM_ETAPA_INTERMEDIARIA.includes(tipoTeste)) {
      setEtapa(1);
      return;
    }
    if (etapa > 1) {
      setEtapa(etapa - 1);
    }
  };

  // Popup de informações
  const [showInfo, setShowInfo] = useState(false);

  const [showInfoProcedimento, setShowInfoProcedimento] = useState(false);
  const hideTimerRef = useRef(null);

  const handleEnter = () => {
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }
    setShowInfoProcedimento(true);
  };

  const [showInfoGeral, setShowInfoGeral] = useState(false);
  const [showInfoApreensao, setShowInfoApreensao] = useState(false);
  const [showInfoFlexao, setShowInfoFlexao] = useState(false);
  const [showInfoAbdominal, setShowInfoAbdominal] = useState(false);
  const [showInfoAgachamento, setShowInfoAgachamento] = useState(false);

  const handleLeave = () => {
    // espera 100ms antes de fechar — evita fechar acidentalmente ao mover entre os elementos
    hideTimerRef.current = setTimeout(() => {
      setShowInfoProcedimento(false);
      hideTimerRef.current = null;
    }, 100);
  };

  // Modal para próxima etapa
  const [isNextModal, setIsNextModal] = useState(false);
  const openNextModal = () => {
    setIsNextModal(true);
  };
  const closeNextModal = () => {
    setIsNextModal(false);
  };

  // SALVAR E BUSCAR NO BD - LEVI
  // -------------------- Dados --------------------------
  const [metodo, setMetodo] = useState('');
  const [tipoTeste, setTipoTeste] = useState('');

  // Todos os testes já registrados nesta avaliação (mais de um pode ser aplicado).
  const [testesRealizados, setTestesRealizados] = useState([]);
  const navigate = useNavigate();
  const [faixasSelecionadas, setFaixasSelecionadas] = useState('');

  const [numRepeticoes, setNumRepeticoes] = useState(0);
  const [forcaApreensaoManual, setForcaApreensaoManual] = useState(0);
  // Preensão manual bilateral: 3 tentativas por mão; a classificação usa o melhor valor da mão dominante.
  const [preensaoDireita, setPreensaoDireita] = useState(['', '', '']);
  const [preensaoEsquerda, setPreensaoEsquerda] = useState(['', '', '']);
  const [maoDominante, setMaoDominante] = useState('Direita');
  const resultadoPreensao = calcularResultadoPreensao({ direita: preensaoDireita, esquerda: preensaoEsquerda, maoDominante });

  const exerciciosDefault = [
    { id: "supino",       nome: "Supino",              carga: "", repeticoes: "" },
    { id: "roscaDireta",  nome: "Rosca direta",        carga: "", repeticoes: "" },
    { id: "puxadaFrente", nome: "Puxada pela frente",  carga: "", repeticoes: "" },
    { id: "legPress",     nome: "Leg press",           carga: "", repeticoes: "" },
    { id: "extensao",     nome: "Cadeira extensora",   carga: "", repeticoes: "" },
    { id: "flexao",       nome: "Mesa flexora",        carga: "", repeticoes: "" },
  ];

  const [exerciciosIniciais, setExerciciosIniciais] = useState(exerciciosDefault);
 
  const [resultado, setResultado] = useState({
    resultadosExercicios: [],
    totalPontos: 0,
    classificacao: null
  });

  
  // Dados antropométricos propagados de evaluationData.antropometria (vide useEffect abaixo).
  const [peso, setPeso] = useState('');
  const [idade, setIdade] = useState('');
  const [sexo, setSexo] = useState('');

  // Tabela de flexoes
  const tabelaFlexaoHomens = {
    "20-29": {
      "Insuficiente": { min: 0, max: 17 },
      "Regular": { min: 17, max: 29 },
      "Bom": { min: 29, max: 39 },
      "Excelente": { min: 39, max: 150 }
    },
    "30-39": {
      "Insuficiente": { min: 0, max: 15 },
      "Regular": { min: 15, max: 24 },
      "Bom": { min: 24, max: 34 },
      "Excelente": { min: 34, max: 150 }
    },
    "40-49": {
      "Insuficiente": { min: 0, max: 13 },
      "Regular": { min: 13, max: 20 },
      "Bom": { min: 20, max: 28 },
      "Excelente": { min: 28, max: 150 }
    },
    "50-59": {
      "Insuficiente": { min: 0, max: 10 },
      "Regular": { min: 10, max: 17 },
      "Bom": { min: 17, max: 24 },
      "Excelente": { min: 24, max: 150 }
    },
    "60+": {
      "Insuficiente": { min: 0, max: 8 },
      "Regular": { min: 8, max: 14 },
      "Bom": { min: 14, max: 20 },
      "Excelente": { min: 20, max: 150 }
    }
  };

  const tabelaFlexaoMulheres = {
    "20-29": {
      "Insuficiente": { min: 0, max: 10 },
      "Regular": { min: 10, max: 18 },
      "Bom": { min: 18, max: 30 },
      "Excelente": { min: 30, max: 150 }
    },
    "30-39": {
      "Insuficiente": { min: 0, max: 8 },
      "Regular": { min: 8, max: 15 },
      "Bom": { min: 15, max: 25 },
      "Excelente": { min: 25, max: 150 }
    },
    "40-49": {
      "Insuficiente": { min: 0, max: 6 },
      "Regular": { min: 6, max: 12 },
      "Bom": { min: 12, max: 20 },
      "Excelente": { min: 20, max: 150 }
    },
    "50-59": {
      "Insuficiente": { min: 0, max: 5 },
      "Regular": { min: 5, max: 10 },
      "Bom": { min: 10, max: 18 },
      "Excelente": { min: 18, max: 150 }
    },
    "60+": {
      "Insuficiente": { min: 0, max: 4 },
      "Regular": { min: 4, max: 8 },
      "Bom": { min: 8, max: 15 },
      "Excelente": { min: 15, max: 150 }
    }
  };

  // Tabela de abdominais
  const tabelaAbdominaisHomens = {
    "20-29": {
      "Insuficiente": { min: 0, max: 29 },   // <30
      "Regular":      { min: 30, max: 39 },  // 30–39
      "Bom":          { min: 40, max: 49 },  // 40–49
      "Excelente":    { min: 50, max: 150 }  // ≥50
    },
    "30-39": {
      "Insuficiente": { min: 0, max: 26 },   // <27
      "Regular":      { min: 27, max: 36 },  // 27–36
      "Bom":          { min: 37, max: 45 },  // 37–45
      "Excelente":    { min: 46, max: 150 }  // ≥46
    },
    "40-49": {
      "Insuficiente": { min: 0, max: 24 },   // <25
      "Regular":      { min: 25, max: 33 },  // 25–33
      "Bom":          { min: 34, max: 42 },  // 34–42
      "Excelente":    { min: 43, max: 150 }  // ≥43
    },
    "50-59": {
      "Insuficiente": { min: 0, max: 21 },   // <22
      "Regular":      { min: 22, max: 30 },  // 22–30
      "Bom":          { min: 31, max: 38 },  // 31–38
      "Excelente":    { min: 39, max: 150 }  // ≥39
    },
    "60+": {
      "Insuficiente": { min: 0, max: 19 },   // <20
      "Regular":      { min: 20, max: 27 },  // 20–27
      "Bom":          { min: 28, max: 35 },  // 28–35
      "Excelente":    { min: 36, max: 150 }  // ≥36
    }
  };

  const tabelaAbdominaisMulheres = {
    "20-29": {
      "Insuficiente": { min: 0, max: 24 },   // <25
      "Regular":      { min: 25, max: 32 },  // 25–32
      "Bom":          { min: 33, max: 42 },  // 33–42
      "Excelente":    { min: 43, max: 150 }  // ≥43
    },
    "30-39": {
      "Insuficiente": { min: 0, max: 21 },   // <22
      "Regular":      { min: 22, max: 30 },  // 22–30
      "Bom":          { min: 31, max: 38 },  // 31–38
      "Excelente":    { min: 39, max: 150 }  // ≥39
    },
    "40-49": {
      "Insuficiente": { min: 0, max: 19 },   // <20
      "Regular":      { min: 20, max: 27 },  // 20–27
      "Bom":          { min: 28, max: 35 },  // 28–35
      "Excelente":    { min: 36, max: 150 }  // ≥36
    },
    "50-59": {
      "Insuficiente": { min: 0, max: 16 },   // <17
      "Regular":      { min: 17, max: 25 },  // 17–25
      "Bom":          { min: 26, max: 32 },  // 26–32
      "Excelente":    { min: 33, max: 150 }  // ≥33
    },
    "60+": {
      "Insuficiente": { min: 0, max: 14 },   // <15
      "Regular":      { min: 15, max: 22 },  // 15–22
      "Bom":          { min: 23, max: 30 },  // 23–30
      "Excelente":    { min: 31, max: 150 }  // ≥31
    }
  };

  // Tabela de agachamentos
  const tabelaAgachamentoHomens = {
    "20-29": {
      "Insuficiente": { min: 0, max: 17 },   // <18
      "Regular":      { min: 18, max: 27 },  // 18–27
      "Bom":          { min: 28, max: 35 },  // 28–35
      "Excelente":    { min: 36, max: 150 }  // ≥36
    },
    "30-39": {
      "Insuficiente": { min: 0, max: 16 },   // <17
      "Regular":      { min: 17, max: 25 },  // 17–25
      "Bom":          { min: 26, max: 33 },  // 26–33
      "Excelente":    { min: 34, max: 150 }  // ≥34
    },
    "40-49": {
      "Insuficiente": { min: 0, max: 14 },   // <15
      "Regular":      { min: 15, max: 23 },  // 15–23
      "Bom":          { min: 24, max: 31 },  // 24–31
      "Excelente":    { min: 32, max: 150 }  // ≥32
    },
    "50-59": {
      "Insuficiente": { min: 0, max: 12 },   // <13
      "Regular":      { min: 13, max: 21 },  // 13–21
      "Bom":          { min: 22, max: 29 },  // 22–29
      "Excelente":    { min: 30, max: 150 }  // ≥30
    },
    "60+": {
      "Insuficiente": { min: 0, max: 11 },   // <12
      "Regular":      { min: 12, max: 19 },  // 12–19
      "Bom":          { min: 20, max: 27 },  // 20–27
      "Excelente":    { min: 28, max: 150 }  // ≥28
    }
  };

  const tabelaAgachamentoMulheres = {
    "20-29": {
      "Insuficiente": { min: 0, max: 14 },   // <15
      "Regular":      { min: 15, max: 22 },  // 15–22
      "Bom":          { min: 23, max: 30 },  // 23–30
      "Excelente":    { min: 31, max: 150 }  // ≥31
    },
    "30-39": {
      "Insuficiente": { min: 0, max: 13 },   // <14
      "Regular":      { min: 14, max: 21 },  // 14–21
      "Bom":          { min: 22, max: 28 },  // 22–28
      "Excelente":    { min: 29, max: 150 }  // ≥29
    },
    "40-49": {
      "Insuficiente": { min: 0, max: 12 },   // <13
      "Regular":      { min: 13, max: 19 },  // 13–19
      "Bom":          { min: 20, max: 26 },  // 20–26
      "Excelente":    { min: 27, max: 150 }  // ≥27
    },
    "50-59": {
      "Insuficiente": { min: 0, max: 10 },   // <11
      "Regular":      { min: 11, max: 17 },  // 11–17
      "Bom":          { min: 18, max: 24 },  // 18–24
      "Excelente":    { min: 25, max: 150 }  // ≥25
    },
    "60+": {
      "Insuficiente": { min: 0, max: 9 },    // <10
      "Regular":      { min: 10, max: 16 },  // 10–16
      "Bom":          { min: 17, max: 23 },  // 17–23
      "Excelente":    { min: 24, max: 150 }  // ≥24
    }
  };

  // Faixas de preensão manual (5 níveis) ficam em utils/preensaoManual.js.

  //Tabela 1 RM resultado
  const tabelaSomatoria1RM = [
    {name: 'Fraca', range: [0, 12], color: '#d70909'},
    {name: 'Satisfatório', range: [12, 24], color: '#ff5e00'},
    {name: 'Média', range: [24, 36], color: '#FFD700'},
    {name: 'Boa', range: [36, 47], color: '#66a3ff'},
    {name: 'Excelente', range: [47, 60], color: '#b3e714'},
  ]

  // Tabela pontos para teste de 1 RM
  const TABELA_PONTOS = {
    Masculino: {
      supino:        [1.50, 1.40, 1.30, 1.20, 1.10, 1.00, 0.90, 0.80, 0.70, 0.60],
      roscaDireta:   [0.70, 0.65, 0.60, 0.55, 0.50, 0.45, 0.40, 0.35, 0.30, 0.25],
      puxadaFrente:  [1.20, 1.15, 1.10, 1.05, 1.00, 0.95, 0.90, 0.85, 0.80, 0.75],
      legPress:      [3.00, 2.80, 2.60, 2.40, 2.20, 2.00, 1.80, 1.60, 1.40, 1.20],
      extensao:      [0.80, 0.75, 0.70, 0.65, 0.60, 0.55, 0.50, 0.45, 0.40, 0.35],
      flexao:        [0.70, 0.65, 0.60, 0.55, 0.50, 0.45, 0.40, 0.35, 0.30, 0.25],
    },
    Feminino: {
      supino:        [0.90, 0.85, 0.80, 0.70, 0.65, 0.60, 0.55, 0.50, 0.45, 0.35],
      roscaDireta:   [0.50, 0.45, 0.42, 0.38, 0.35, 0.32, 0.28, 0.25, 0.21, 0.18],
      puxadaFrente:  [0.85, 0.80, 0.75, 0.73, 0.70, 0.65, 0.63, 0.60, 0.55, 0.50],
      legPress:      [2.70, 2.50, 2.30, 2.10, 2.00, 1.80, 1.60, 1.40, 1.20, 1.00],
      extensao:      [0.70, 0.65, 0.60, 0.55, 0.52, 0.50, 0.45, 0.40, 0.35, 0.30],
      flexao:        [0.60, 0.55, 0.52, 0.50, 0.45, 0.40, 0.35, 0.30, 0.25, 0.20],
    },
  };

  function calcular1RM(carga, repeticoes) {
    if (!carga || !repeticoes || repeticoes >= 37) return 0;
    return (carga * 36) / (37 - repeticoes);
  }

  function getPontosExercicio(sexo, exercicioId, forcaRelativa) {
    const thresholds = TABELA_PONTOS[sexo][exercicioId];
    if (!thresholds || !forcaRelativa) return 0;

    // thresholds em ordem do 10 → 1 ponto
    for (let i = 0; i < thresholds.length; i++) {
      if (forcaRelativa >= thresholds[i]) {
        return 10 - i;
      }
    }
    return 0; // abaixo do mínimo da tabela
  }

  function classificarTotal(total) {
    if (total >= 48) return "Excelente";
    if (total >= 37) return "Boa";
    if (total >= 25) return "Média";
    if (total >= 13) return "Satisfatória";
    return "Fraca";
  }

  const calcularTudo = () => {
    const resultadosExercicios = (exerciciosIniciais || []).map((ex) => {
      const oneRM = calcular1RM(ex.carga, ex.repeticoes);
      const forcaRelativa = peso > 0 ? oneRM / peso : 0;
      const pontos = getPontosExercicio(sexo, ex.id, forcaRelativa);

      return {
        ...ex,
        oneRM,
        forcaRelativa,
        pontos,
      };
    });

    const totalPontos = resultadosExercicios.reduce(
      (acc, ex) => acc + ex.pontos,
      0
    );

    const classificacao = classificarTotal(totalPontos);

    setResultado({ resultadosExercicios, totalPontos, classificacao });
  };

  // Altera os dados do estado "exerciciosInicias" dos testes de RM
  const handleChange = (index, campo, valor) => {
    const copia = [...exerciciosIniciais];
    copia[index][campo] = valor === "" ? "" : Number(valor);
    setExerciciosIniciais(copia);
  };

  // Seleciona o intervalo na tabela de acordo com a idade
  function encontraFaixas() {
    // Só calcula faixas se o tipo de teste for um dos dois
    if (tipoTeste !== "BracosAgachamentoAbdominais" && tipoTeste !== "ApreensaoManual") {
      setFaixasSelecionadas([]);
      return;
    }

    // Se ainda não tem método/sexo/idade definidos, não faz nada
    if (!metodo || !sexo || !idade) {
      setFaixasSelecionadas([]);
      return;
    }

    // Preensão manual: faixas de 5 níveis do módulo compartilhado (mesmas do relatório).
    if (tipoTeste === "ApreensaoManual") {
      setFaixasSelecionadas(faixasPreensaoManual(sexo, idade));
      return;
    }

    let tabelasPorMetodo;

    if (tipoTeste === "BracosAgachamentoAbdominais") {
      tabelasPorMetodo = {
        FlexaoBraco: {
          Masculino: tabelaFlexaoHomens,
          Feminino: tabelaFlexaoMulheres,
        },
        Abdominal: {
          Masculino: tabelaAbdominaisHomens,
          Feminino: tabelaAbdominaisMulheres,
        },
        Agachamento: {
          Masculino: tabelaAgachamentoHomens,
          Feminino: tabelaAgachamentoMulheres,
        },
      };
    }

    const tabelas = tabelasPorMetodo?.[metodo];

    // Se o método não tiver tabela mapeada, evita o erro
    if (!tabelas) {
      console.warn("Método sem tabela mapeada:", { tipoTeste, metodo });
      setFaixasSelecionadas([]);
      return;
    }

    const cores = {
      Excelente: "#00c457",
      Bom: "#66a3ff",
      Regular: "#ffbb28",
      Insuficiente: "#fb1d1d",
    };

    const tabela = sexo === "Feminino" ? tabelas.Feminino : tabelas.Masculino;

    if (!tabela) {
      console.warn("Sexo sem tabela definida:", { metodo, sexo });
      setFaixasSelecionadas([]);
      return;
    }

    const idadeNumero = Number(idade);
    let faixaEncontrada = null;

    for (const faixa in tabela) {
      if (faixa.includes("+")) {
        const min = parseInt(faixa.replace("+", ""));
        if (idadeNumero >= min) faixaEncontrada = faixa;
      } else {
        const [min, max] = faixa.split("-").map(Number);
        if (idadeNumero >= min && idadeNumero <= max) faixaEncontrada = faixa;
      }
    }

    if (!faixaEncontrada) {
      console.warn("Nenhuma faixa encontrada:", { idadeNumero, metodo, sexo });
      setFaixasSelecionadas([]);
      return;
    }

    const faixasObj = tabela[faixaEncontrada];

    if (!faixasObj) {
      console.warn("Faixa não existe na tabela:", { faixaEncontrada, metodo, sexo });
      setFaixasSelecionadas([]);
      return;
    }

    const faixasArray = Object.keys(faixasObj).map((categoria) => {
      const { min, max } = faixasObj[categoria];
      return {
        name: categoria,
        range: [min, max],
        color: cores[categoria] || "#000",
      };
    });

    console.log(faixasArray);

    setFaixasSelecionadas(faixasArray);
  }

  useEffect(() => {
    encontraFaixas();
  }, [tipoTeste, metodo, sexo, idade]);

  // Encontra as faixas mais gerais de classificação pra exibir nos resultados
  function encontrarFaixa(valor, faixas) {
    return faixas.find((faixa) =>
      valor >= faixa.range[0] && valor <= faixa.range[1]
    );
  }

  // Cria o gráfico de barra com o indicador
  const GraficoBarraComIndicador = ({
    valor,
    faixas,
    largura = 340,
    altura = 25,
    corIndicador = "#fff",
    mostrarValor = false,
  }) => {
    const larguraSegmento = largura / faixas.length;
  
    // Encontra a faixa correspondente ao valor
    const faixaIndex = faixas.findIndex(
      (faixa) => valor >= faixa.range[0] && valor <= faixa.range[1]
    );
  
    let posicaoSeta = 0;
  
    if (faixaIndex !== -1) {
      const faixa = faixas[faixaIndex];
      const [min, max] = faixa.range;
      const percentualNaFaixa = (valor - min) / (max - min); // valor entre 0 e 1
  
      posicaoSeta = faixaIndex * larguraSegmento + percentualNaFaixa * larguraSegmento;
    }
  
    return (
      <div style={{ position: "relative", marginTop: "0px" }}>
        {/* Indicador (seta) */}
        <div
          style={{
            position: "absolute",
            left: `${posicaoSeta}px`,
            top: "10px",
            transform: "translateX(-50%) translateY(-14px)",
            fontSize: "20px",
            color: corIndicador,
            whiteSpace: "nowrap",
          }}
        >
          <img className="indicador-img" src={Indicador} alt="▲" />
          {mostrarValor && formatarNumero(valor, 1)}
        </div>
  
        {/* Barra segmentada com faixas de largura igual ▲ <img className="arrow-icon" src={LeviIcon} alt="corpo-humano" />*/}
        <div
          style={{
            display: "flex",
            height: `${altura}px`,
            width: `${largura}px`,
            overflow: "hidden",
            boxShadow: "0 0 4px rgba(0,0,0,0.1)",
          }}
        >
          {faixas.map((faixa, index) => {
            const borderRadiusStyle = {
              borderTopLeftRadius: index === 0 ? "2px" : "0px",
              borderBottomLeftRadius: index === 0 ? "2px" : "0px",
              borderTopRightRadius: index === faixas.length - 1 ? "2px" : "0px",
              borderBottomRightRadius: index === faixas.length - 1 ? "2px" : "0px",
            };
  
            return (
              <div
                key={index}
                style={{
                  width: `${larguraSegmento}px`,
                  backgroundColor: faixa.color,
                  ...borderRadiusStyle,
                }}
                title={`${faixa.name} (${faixa.range[0]} - ${faixa.range[1]})`}
              />
            );
          })}
        </div>
      </div>
    );
  };

  useEffect(() => {
    // Propaga dados da Antropometria (precedência: avaliacaoNeuromuscular próprio sobrescreve abaixo).
    if (evaluationData?.antropometria) {
      const a = evaluationData.antropometria;
      if (a.peso !== undefined) setPeso(a.peso);
      if (a.idade !== undefined) setIdade(a.idade);
      if (a.sexo) setSexo(a.sexo);
    }

    if (evaluationData?.avaliacaoNeuromuscular) {
      const n = evaluationData.avaliacaoNeuromuscular;
      if (n.metodo) setMetodo(n.metodo);
      if (n.tipoTeste) setTipoTeste(n.tipoTeste);
      if (n.faixasSelecionadas) setFaixasSelecionadas(n.faixasSelecionadas);
      if (n.numRepeticoes) setNumRepeticoes(n.numRepeticoes);
      if (n.forcaApreensaoManual) setForcaApreensaoManual(n.forcaApreensaoManual);
      if (n.preensaoManual) {
        const pm = n.preensaoManual;
        if (Array.isArray(pm.direita)) setPreensaoDireita([0, 1, 2].map((i) => pm.direita[i] ?? ''));
        if (Array.isArray(pm.esquerda)) setPreensaoEsquerda([0, 1, 2].map((i) => pm.esquerda[i] ?? ''));
        if (pm.maoDominante) setMaoDominante(pm.maoDominante);
      }
      if (n.exerciciosIniciais) setExerciciosIniciais(n.exerciciosIniciais);
      if (n.resultado) setResultado(n.resultado);
      if (Array.isArray(n.testesRealizados)) setTestesRealizados(n.testesRealizados);
    }
  }, [evaluationData]);

  // forcaApreensaoManual continua sendo o valor usado na classificação, no relatório e no comparativo:
  // agora é o melhor resultado da mão dominante.
  useEffect(() => {
    if (metodo !== 'ApreensaoManual') return;
    setForcaApreensaoManual(resultadoPreensao.valorDominante ?? 0);
  }, [metodo, preensaoDireita, preensaoEsquerda, maoDominante]);

  const handleNeuromuscularRegister = async () => {
    const preensaoManual = metodo === 'ApreensaoManual'
      ? {
          direita: preensaoDireita,
          esquerda: preensaoEsquerda,
          maoDominante: resultadoPreensao.maoDominante,
          melhorDireita: resultadoPreensao.melhorDireita,
          melhorEsquerda: resultadoPreensao.melhorEsquerda,
          assimetriaPercentual: resultadoPreensao.assimetriaPercentual,
          maoMaisForte: resultadoPreensao.maoMaisForte,
          classificacao: encontrarFaixa(forcaApreensaoManual, faixasSelecionadas)?.name || null,
        }
      : null;
    const testeAtual = {
      metodo, tipoTeste, faixasSelecionadas,
      numRepeticoes, forcaApreensaoManual, preensaoManual,
      exerciciosIniciais, resultado
    };
    // Refazer um teste do mesmo método substitui o registro anterior dele.
    const listaAtualizada = [...testesRealizados.filter((t) => t.metodo !== metodo), testeAtual];

    const payload = {
      avaliacaoNeuromuscular: { ...testeAtual, testesRealizados: listaAtualizada },
      evaluationId
    };

    try {
      const response = await api.post(`/api/student/${aluno.id}/evaluation/avaliacao-neuromuscular`, payload, { withCredentials: true });
      if (response.status === 200) {
        if (response.data.evaluationId && setEvaluationId) {
          if (!evaluationId) {
            if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
            aluno.avaliacoesRealizadas.push({
              id: response.data.evaluationId,
              data: new Date().toISOString()
            });
          }
          setEvaluationId(response.data.evaluationId);
        }
        if (updateEvaluationData) {
          updateEvaluationData({ avaliacaoNeuromuscular: payload.avaliacaoNeuromuscular });
        }
        setTestesRealizados(listaAtualizada);
        openNextModal();
      }
    } catch (error) {
      console.error('Erro ao salvar Avaliação Neuromuscular:', error);
    }
  };

  // Navegação provisória
  // Limpa os campos do teste atual para aplicar outro teste na mesma avaliação.
  const iniciarNovoTeste = () => {
    setTipoTeste('');
    setMetodo('');
    setFaixasSelecionadas('');
    setNumRepeticoes(0);
    setForcaApreensaoManual(0);
    setPreensaoDireita(['', '', '']);
    setPreensaoEsquerda(['', '', '']);
    setMaoDominante('Direita');
    setExerciciosIniciais(exerciciosDefault);
    setResultado({ resultadosExercicios: [], totalPontos: 0, classificacao: null });
    setEtapa(1);
    closeNextModal();
  };

  // Encerra a avaliação e volta para a tela do aluno.
  const finalizarAvaliacao = () => {
    closeNextModal();
    navigate('/home-aluno', { state: { alunoSelecionado: aluno } });
  };

  // CAP-3: bloqueia se a etapa-fonte (Antropometria) não foi preenchida.
  const antropometriaPresente = evaluationData?.antropometria?.peso !== undefined;
  if (!antropometriaPresente) {
    return (
      <EtapaFonteAusente
        etapaAtual="Avaliação Neuromuscular"
        etapasFontes={[
          { nome: 'Antropometria', tabKey: 'Antropometria', presente: antropometriaPresente },
        ]}
        setActiveTab={setActiveTab}
      />
    );
  }

  return (
    <div className="avaliacao-container">
      <div className="avaliacao-content">
        {etapa === 1 && (
          <div className="questions-container">
            <div className="questions-left">
              <div className="question-item">
                <div className="question-title">Avaliacão Neuromuscular - Selecione o tipo do teste</div>
                  <div className="selecao-metodo-container">
                    <button className="next-prev-button btt-avaliacao-neuro metodo-button metodo-unificado" type="button" onClick={() => {setTipoTeste("ForcaRelativa"); setMetodo("ForcaGeral"); setEtapa(3);}}>
                      <img src={IconMusculo} alt="Esteira" />
                      Teste de Força Relativa
                    </button>
                    <button className="next-prev-button btt-avaliacao-neuro metodo-button metodo-unificado" type="button" onClick={() => {setTipoTeste("ApreensaoManual"); setMetodo("ApreensaoManual"); setEtapa(3);}}>
                      <img src={IconAgachamento} alt="Esteira" />
                      Teste de Apreensão Manual
                    </button>
                    <button className="next-prev-button btt-avaliacao-neuro metodo-button metodo-unificado" type="button" onClick={() => {setTipoTeste("BracosAgachamentoAbdominais"); setEtapa(2);}}>
                      <img src={IconAgachamento} alt="Esteira" />
                      Teste de Flexão de Braços, Agachamento e Abdominais
                    </button>
                  </div>
              </div>
            </div>
          </div>
        )}

        {etapa === 2 && (
          <div className="questions-container">
            <div className="questions-left">
              {tipoTeste === 'BracosAgachamentoAbdominais' && (
                <div className="question-item">
                  <div className="question-title">Teste de Flexão de Braços, Agachamento e Abdominais</div>
                  <div className="selecao-testes-vo2-container pad-top-5">
                    <ul className="metodos-vo2-list">
                      <li className="" onClick={() => {setMetodo('FlexaoBraco'); setEtapa(3);}}>Teste de Flexão de Braços (Força de Membros Superiores)</li>
                      <li className="" onClick={() => {setMetodo('Abdominal'); setEtapa(3);}}>Teste de Abdominal (Força de Tronco)</li>
                      <li className="" onClick={() => {setMetodo('Agachamento'); setEtapa(3);}}>Teste de Agachamento (Força de Membros Inferiores)</li>
                    </ul>
                  </div>
                </div>
              )}
              {tipoTeste === 'ApreensaoManual' && (
                <div className="question-item">
                  <div className="question-title">Teste de Apreensão Manual</div>
                  <div className="selecao-testes-vo2-container pad-top-5">
                    <ul className="metodos-vo2-list">
                      <li className="" onClick={() => {setMetodo('ApreensaoManual'); setEtapa(3);}}>Teste de Apreensão Manual (Dinamometria)</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {etapa === 3 && (
          <div className="questions-container">
            <div className="questions-left">
              {metodo === 'FlexaoBraco' &&(
                <div>
                  <div className="standard-title title-with-info-box">
                    Teste de Flexão de Braços (Força de Membros Superiores)
                    <div className="info-box-container" onMouseEnter={() => setShowInfoFlexao(true)} onMouseLeave={() => setShowInfoFlexao(false)}>
                      <div className="info-icon">
                          <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoFlexao && (
                            <div className="info-box-content" style={{ transform: 'translateX(-10vw) translateY(25vh)' }}>
                                <p className="">
                                    O teste de flexão de braços avalia a resistência muscular de membros superiores, especialmente peitorais, ombros e tríceps, por meio da execução repetida do movimento. É uma ferramenta prática para mensurar resistência muscular localizada e capacidade funcional.
                                </p>
                            </div>
                        )}
                    </div>
                  </div>
                  <div style={{ position: "relative", display: "inline-block", paddingTop: 10 }}>
                    <a
                      className="btt-vo2-procedimentos margin-top-5"
                      onMouseEnter={() => setShowInfoProcedimento(true)}
                      onMouseLeave={() => setShowInfoProcedimento(false)}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div
                        className="info-box-procedimentos"
                        onMouseEnter={handleEnter} // mantém aberto enquanto o mouse está sobre a caixa
                        onMouseLeave={handleLeave}
                        role="dialog"
                        aria-label="Informações sobre procedimentos"
                      >
                        <p>
                          <b>Objetivo: </b>
                          Avaliar a resistência de força dos músculos extensores dos cotovelos e estabilizadores do tronco, principalmente peitoral maior, tríceps braquial e deltoides.
                          <br/><br/>
                          <b>Equipamentos: </b>
                            •	Colchonete ou piso antiderrapante;<br/>
                            •	Cronômetro;<br/>
                            •	Marcador de contagem (avaliador).
                          <br/><br/>
                          <b>Procedimento para o teste (ACSM, 2022):</b>
                            1. O avaliado posiciona-se em decúbito ventral, mãos alinhadas aos ombros, corpo estendido (homens: ponta dos pés; mulheres: joelhos no chão).<br/>
                            2. O avaliador comanda: “Desce até 90° de cotovelo e retorna à extensão completa.”<br/>
                            3. Movimento contínuo e ritmado, sem pausas prolongadas (maior que 3 seg).<br/>
                            4. O teste termina quando:<br/>
                            •	O avaliado perde a postura;<br/>
                            •	Não atinge 90° de flexão;<br/>
                            •	Faz pausa prolongada;<br/>
                            •	Ou completa o tempo máximo (geralmente 1 minuto).<br/>
                            5. Registrar o número de repetições corretas.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com o número de repetições: </b>
                    <input className="entrada-tabela-vo2" type="text" name="numRepeticoes" placeholder={numRepeticoes} value={numRepeticoes} onChange={e => setNumRepeticoes(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'Abdominal' &&(
                <div>
                  <div className="standard-title title-with-info-box">
                    Teste de Abdominal (Força de Tronco)
                    <div className="info-box-container" onMouseEnter={() => setShowInfoAgachamento(true)} onMouseLeave={() => setShowInfoAgachamento(false)}>
                      <div className="info-icon">
                          <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoAgachamento && (
                            <div className="info-box-content" style={{ transform: 'translateX(5vw) translateY(25vh)' }}>
                                <p className="">
                                    O teste de flexão de braços avalia a resistência muscular de membros superiores, especialmente peitorais, ombros e tríceps, por meio da execução repetida do movimento. É uma ferramenta prática para mensurar resistência muscular localizada e capacidade funcional.
                                </p>
                            </div>
                        )}
                    </div>
                  </div>
                  <div style={{ position: "relative", display: "inline-block", paddingTop: 10 }}>
                    <a
                      className="btt-vo2-procedimentos"
                      onMouseEnter={() => setShowInfoProcedimento(true)}
                      onMouseLeave={() => setShowInfoProcedimento(false)}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div
                        className="info-box-procedimentos"
                        onMouseEnter={handleEnter} // mantém aberto enquanto o mouse está sobre a caixa
                        onMouseLeave={handleLeave}
                        role="dialog"
                        aria-label="Informações sobre procedimentos"
                      >
                        <p>
                          <b>Objetivo: </b>
                          Avaliar a resistência muscular abdominal, principalmente do reto abdominal e flexores do quadril.
                          <br/><br/>
                          <b>Equipamentos: </b>
                            •	Colchonete;<br/>
                            •	Cronômetro;<br/>
                            •	Faixa de 10 cm (para protocolo de “curl-up” ACSM, opcional);<br/>
                            •	Avaliador para estabilizar os pés, se necessário.
                          <br/><br/>
                          <b>Procedimento para o teste (ACSM, 2022):</b>
                            1. O avaliado deita em decúbito dorsal, joelhos flexionados a 90°, pés apoiados e braços cruzados sobre o peito.<br/>
                            2. Ao comando “suba até tocar as coxas com os cotovelos e retorne até tocar o solo”, realiza o máximo de repetições em 1 minuto.<br/>
                            3. O ritmo é livre, mas sem impulso de braços ou pescoço.<br/>
                            4. O teste termina com interrupção, dor ou após 60 segundos.<br/>
                            5. Registrar o número total de repetições corretas.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com o número de repetições: </b>
                    <input className="entrada-tabela-vo2" type="text" name="numRepeticoes" placeholder={numRepeticoes} value={numRepeticoes} onChange={e => setNumRepeticoes(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'Agachamento' &&(
                <div>
                  <div className="standard-title title-with-info-box">
                    Teste de Agachamento (Força de Membros Inferiores)
                    <div className="info-box-container" onMouseEnter={() => setShowInfoAgachamento(true)} onMouseLeave={() => setShowInfoAgachamento(false)}>
                      <div className="info-icon">
                          <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoAgachamento && (
                            <div className="info-box-content" style={{ transform: 'translateX(-10vw) translateY(25vh)' }}>
                                <p className="">
                                    O teste abdominal mensura a resistência muscular da região do core, especialmente musculatura abdominal, importante para estabilidade, postura e eficiência funcional. É amplamente utilizado para avaliação do condicionamento muscular localizado e suporte à prescrição de treinamento.
                                </p>
                            </div>
                        )}
                    </div>
                  </div>
                  <div style={{ position: "relative", display: "inline-block", paddingTop: 10 }}>
                    <a
                      className="btt-vo2-procedimentos"
                      onMouseEnter={() => setShowInfoProcedimento(true)}
                      onMouseLeave={() => setShowInfoProcedimento(false)}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div
                        className="info-box-procedimentos"
                        onMouseEnter={handleEnter} // mantém aberto enquanto o mouse está sobre a caixa
                        onMouseLeave={handleLeave}
                        role="dialog"
                        aria-label="Informações sobre procedimentos"
                      >
                        <p>
                          <b>Objetivo: </b>
                          Avaliar a resistência de força dos músculos extensores dos joelhos e quadris, especialmente quadríceps, glúteos e isquiotibiais.
                          <br/><br/>
                          <b>Equipamentos: </b>
                            •	Cadeira (altura padrão ~43 cm);<br/>
                            •	Cronômetro;<br/>
                            •	Espaço livre e seguro.
                          <br/><br/>
                          <b>Procedimento para o teste (ACSM, 2022):</b>
                            1. O avaliado senta-se no centro da cadeira, com pés paralelos, braços cruzados sobre o peito.<br/>
                            2. Ao sinal “já!”, realiza o maior número de repetições possíveis em 30 segundos, levantando-se completamente e sentando novamente com controle.<br/>
                            3. O avaliador conta apenas repetições completas.<br/>
                            4. O teste termina após 30 segundos ou com perda de técnica.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className='pad-top-20'>
                    <b className='entrada-tempo-outros'>Entre com o número de repetições: </b>
                    <input className="entrada-tabela-vo2" type="text" name="numRepeticoes" placeholder={numRepeticoes} value={numRepeticoes} onChange={e => setNumRepeticoes(e.target.value)} />
                  </div>
                </div>
              )}
              {metodo === 'ApreensaoManual' &&(
                <div>
                  <div className="standard-title title-with-info-box">
                    Teste de Apreensão Manual (Dinamometria)
                    <div className="info-box-container" onMouseEnter={() => setShowInfoApreensao(true)} onMouseLeave={() => setShowInfoApreensao(false)}>
                      <div className="info-icon">
                          <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoApreensao && (
                            <div className="info-box-content" style={{ transform: 'translateX(0vw) translateY(25vh)' }}>
                                <p className="">
                                    O teste de preensão manual mensura a força de preensão das mãos por meio de um dinamômetro, sendo um importante indicador de força global, funcionalidade e saúde neuromuscular. No PersonalMetrics o protocolo é bilateral: 3 tentativas em cada mão, alternadamente, registrando o melhor resultado de cada lado. A classificação considera o valor da mão dominante, e a comparação entre os dois lados permite identificar assimetrias.
                                </p>
                            </div>
                        )}
                    </div>
                  </div>
                  <div style={{ position: "relative", display: "inline-block", paddingTop: 10 }}>
                    <a
                      className="btt-vo2-procedimentos"
                      onMouseEnter={handleEnter}
                      onMouseLeave={handleLeave}
                      onFocus={handleEnter}   // acessibilidade: abre ao focar via teclado
                      onBlur={handleLeave}
                      tabIndex={0}
                      aria-haspopup="dialog"
                      aria-expanded={showInfoProcedimento}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div
                        className="info-box-procedimentos"
                        onMouseEnter={handleEnter} // mantém aberto enquanto o mouse está sobre a caixa
                        onMouseLeave={handleLeave}
                        role="dialog"
                        aria-label="Informações sobre procedimentos"
                      >
                        <p>
                          <b>Objetivo: </b><br/>
                          Avaliar a força isométrica máxima dos músculos flexores da mão e do antebraço, refletindo a força geral de membros superiores e a aptidão funcional global.
                          O teste é realizado bilateralmente (mão direita e mão esquerda), o que permite analisar a força de preensão, comparar os membros e identificar possíveis assimetrias.
                          <br/><br/>
                          <b>Equipamentos: </b><br/>
                            • Dinamômetro manual (ex.: Takei, Jamar, Baseline, Saehan ou similar);<br/>
                            • Cadeira sem apoio de braços;<br/>
                            • Ficha ou sistema para registro de dados.
                          <br/><br/>
                          <b>Preparação:</b><br/>
                            O avaliado deve estar sentado ou em pé, com:<br/>
                            • Ombro em posição neutra (sem rotação ou elevação);<br/>
                            • Cotovelo flexionado a 90°;<br/>
                            • Antebraço em posição neutra;<br/>
                            • Punho entre 0° e 30° de extensão, e até 15° de desvio ulnar;<br/>
                            • A posição deve ser padronizada para ambos os lados (direito e esquerdo).
                          <br/><br/>
                          <b>Execução:</b><br/>
                            1. Ajustar a empunhadura do dinamômetro de forma que a segunda falange dos dedos faça o contato principal.<br/>
                            2. Solicitar ao avaliado que pressione o mais forte possível o dinamômetro, sem movimento do braço ou do corpo.<br/>
                            3. Instrução padronizada: “Aperte o mais forte que conseguir agora… força… força… e relaxa.”<br/>
                            4. Duração do esforço: cerca de 3 a 5 segundos.<br/>
                            5. Realizar 3 tentativas em cada mão, alternando os lados (direita, esquerda, direita...), com 30 a 60 segundos de descanso entre as tentativas.<br/>
                            6. Registrar as 3 tentativas de cada mão; o sistema considera o melhor valor (kgf) de cada lado.
                          <br/><br/>
                          <b>Classificação:</b><br/>
                            A classificação normativa usa o melhor valor da mão dominante. Os valores das duas mãos ficam disponíveis para a análise da simetria bilateral.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className='pad-top-20'>
                    <p className="info-sugerido" style={{ margin: '0 0 10px 0' }}>{PROTOCOLO_PREENSAO_MANUAL}</p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                      <b className='entrada-tempo-outros'>Mão dominante: </b>
                      <select className="selecao-protocolo" value={maoDominante} onChange={e => setMaoDominante(e.target.value)}>
                        <option value="Direita">Direita</option>
                        <option value="Esquerda">Esquerda</option>
                      </select>
                    </div>
                    <table className='tabela-rm-dados' border="1" cellPadding="6" style={{ borderCollapse: 'collapse', width: '100%' }}>
                      <thead>
                        <tr>
                          <th>Tentativa</th>
                          <th>Mão direita (kgf)</th>
                          <th>Mão esquerda (kgf)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[0, 1, 2].map((i) => (
                          <tr key={i}>
                            <td style={{ textAlign: 'center' }}>{i + 1}ª</td>
                            <td style={{ textAlign: 'center' }}>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                inputMode="decimal"
                                name={`preensaoDireita${i + 1}`}
                                value={preensaoDireita[i]}
                                onChange={e => setPreensaoDireita(preensaoDireita.map((v, j) => (j === i ? e.target.value : v)))}
                              />
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <input
                                className="entrada-tabela-vo2"
                                type="text"
                                inputMode="decimal"
                                name={`preensaoEsquerda${i + 1}`}
                                value={preensaoEsquerda[i]}
                                onChange={e => setPreensaoEsquerda(preensaoEsquerda.map((v, j) => (j === i ? e.target.value : v)))}
                              />
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td style={{ textAlign: 'center' }}><b>Melhor valor</b></td>
                          <td style={{ textAlign: 'center' }}><b>{resultadoPreensao.melhorDireita ?? '-'}</b></td>
                          <td style={{ textAlign: 'center' }}><b>{resultadoPreensao.melhorEsquerda ?? '-'}</b></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {metodo === 'ForcaGeral' &&(
                <div>
                  <div className="standard-title title-with-info-box">
                    Teste de Força Geral
                    <div className="info-box-container" onMouseEnter={() => setShowInfoGeral(true)} onMouseLeave={() => setShowInfoGeral(false)}>
                      <div className="info-icon">
                          <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoGeral && (
                            <div className="info-box-content" style={{ transform: 'translateX(5vw) translateY(30vh)' }}>
                                <p className="">
                                    A análise por dobras cutâneas é realizada por meio da mensuração da espessura da gordura subcutânea em pontos anatômicos específicos, utilizando um adipômetro. A partir desses dados, é possível estimar o percentual de gordura corporal de forma mais precisa, sendo um dos métodos mais utilizados na avaliação física para acompanhamento de emagrecimento, hipertrofia e planejamento de estratégias de treinamento e nutrição.
                                </p>
                            </div>
                        )}
                    </div>
                  </div>
                  <div style={{ position: "relative", display: "inline-block", paddingTop: 10}}>
                    <a
                      className="btt-vo2-procedimentos"
                      onMouseEnter={handleEnter}
                      onMouseLeave={handleLeave}
                      onFocus={handleEnter}   // acessibilidade: abre ao focar via teclado
                      onBlur={handleLeave}
                      tabIndex={0}
                      aria-haspopup="dialog"
                      aria-expanded={showInfoProcedimento}
                    >
                      Procedimentos para realização do teste
                    </a>
                    {showInfoProcedimento && (
                      <div
                        className="info-box-procedimentos"
                        onMouseEnter={handleEnter} // mantém aberto enquanto o mouse está sobre a caixa
                        onMouseLeave={handleLeave}
                        role="dialog"
                        aria-label="Informações sobre procedimentos"
                      >
                        <p>
                          <b>Objetivo: </b>
                            Estimar a 1RM de forma indireta a partir de um teste de múltiplas repetições (3 - 10RM), aplicável ao supino reto (força relativa MMSS) e ao leg press (força relativa MMII).
                          <br/><br/>
                          <b>Materiais e preparo: </b><br/>
                          •	Barra/máquina aferidas; anotar modelo do leg press e o peso do trenó (se aplicável).<br/>
                          •	Anotar: massa corporal (kg), exercício, carga (kg), repetições válidas, técnica/ROM.<br/>
                          •	Spotter no supino; travas de segurança.<br/>
                          •	Aquecimento geral (5 - 10 min) + mobilidade específica.
                          <br/><br/>
                          <b>Procedimento padronizado (por exercício):</b><br/>
                            1.	Aquecimento específico<br/>
                            <p className='lista-tab-10'>
                              •	10 rep a ~50% da 1RM estimada (ou carga leve) → repouso 1 - 2 min. Science for Sport<br/>
                              •	6 - 8 rep a ~60 - 70% estimado → 2 - 3 min. Science for Sport<br/>
                            </p>
                            2.	Séries de aproximação<br/>
                            <p className='lista-tab-10'>
                              •	3 - 5 rep a ~75 - 85% estimado → 2 - 3 min.<br/>
                              •	Se a técnica estiver estável, partir para tentativa de RM-alvo (3 - 10RM). Objetivo: falha concêntrica técnica entre 3 e 10 rep. Science for Sport+1<br/>
                            </p>
                            3.	Tentativa válida (3 - 10RM)<br/>
                            <p className='lista-tab-10'>
                              •	Cadência controlada, ROM completo e padrão de movimento consistente (supino: toque no peito sem “quicar” e extensão total sem hiperextensão; leg press: ângulo de joelho ≥90° sem retroversão pélvica).<br/>
                              •	Se o aluno fez mais que10 rep, aumente 2,5 - 10% e repita após 3 - 5 min. Se fez menos que 3 rep, reduza 2,5 - 10%. Limite a 3 - 5 tentativas totais. contentcdn.eacefitness.com+1<br/>
                            </p>
                            4.	Registre: maior carga (kg) x repetições válidas (R). Essa é a entrada das fórmulas.

                          <br/><br/>
                          <b>Execução:</b><br/>
                            1.	Ajustar a empunhadura do dinamômetro de forma que a segunda falange dos dedos faça o contato principal.<br/>
                            2.	Solicitar ao avaliado que pressione o mais forte possível o dinamômetro, sem movimento do braço ou do corpo.<br/>
                            3.	Instrução padronizada:
                            “Aperte o mais forte que conseguir agora… força… força… e relaxa.”<br/>
                            4.	Duração do esforço: cerca de 3 a 5 segundos.<br/>
                            5.	Realizar 3 tentativas por mão, alternando os lados (com 30 a 60 segundos de descanso entre tentativas).<br/>
                            6.	Registrar o melhor valor (kgf) de cada mão.
                        </p>
                      </div>
                    )}
                  </div>
                  <div className='pad-top-10'>
                    <b className='entrada-tempo-outros'>Entre com a carga e as repetições dos exercícios realizados:</b>
                    <table className='tabela-rm-dados' border="1" cellPadding="6" style={{ borderCollapse: "collapse" }}>
                      <thead>
                        <tr>
                          <th>Exercício</th>
                          <th>Carga</th>
                          <th>Repetições</th>
                        </tr>
                      </thead>

                      <tbody>
                        {exerciciosIniciais.map((ex, index) => (
                          <tr key={ex.nome}>
                            <td>{ex.nome}</td>

                            <td>
                              <input
                                type="number"
                                value={ex.carga}
                                min="0"
                                onChange={(e) =>
                                  handleChange(index, "carga", e.target.value)
                                }
                              />
                            </td>

                            <td>
                              <input
                                type="number"
                                value={ex.repeticoes}
                                min="0"
                                onChange={(e) =>
                                  handleChange(index, "repeticoes", e.target.value)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button className='next-prev-button' style={{ marginTop: 12 }} onClick={calcularTudo}>
                      Calcular pontos
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="questions-right">
              <div className="question-title">Resultados</div>
                {(metodo === 'FlexaoBraco' || metodo === 'Abdominal' || metodo === 'Agachamento') &&(
                  <div className="resultado-vo2-container pad-top-10">
                    <GraficoBarraComIndicador valor={numRepeticoes} faixas={faixasSelecionadas} />
                    {encontrarFaixa(numRepeticoes, faixasSelecionadas) && (
                    <div
                        className="resultado-classificacao margin-top-15"
                        style={{ border: `2px solid ${encontrarFaixa(numRepeticoes, faixasSelecionadas)?.color}`}}>
                        <span>
                          Classificação: <strong>{encontrarFaixa(numRepeticoes, faixasSelecionadas)?.name}</strong>
                        </span>
                      </div>
                    )}

                  </div>
                )}
                {(metodo === 'ApreensaoManual') &&(
                  <div className="resultado-vo2-container pad-top-10">
                    <GraficoBarraComIndicador valor={forcaApreensaoManual} faixas={faixasSelecionadas} />
                    {encontrarFaixa(forcaApreensaoManual, faixasSelecionadas) && (
                    <div
                        className="resultado-classificacao margin-top-15"
                        style={{ border: `2px solid ${encontrarFaixa(forcaApreensaoManual, faixasSelecionadas)?.color}`}}>
                        <span>
                          Classificação: <strong>{encontrarFaixa(forcaApreensaoManual, faixasSelecionadas)?.name}</strong>
                        </span>
                      </div>
                    )}
                    {(resultadoPreensao.melhorDireita !== null || resultadoPreensao.melhorEsquerda !== null) && (
                      <div className="pad-top-10">
                        <p className="adicional-info-content" style={{ margin: '4px 0' }}>
                          <strong>Mão dominante ({resultadoPreensao.maoDominante}):</strong> {resultadoPreensao.valorDominante ?? '-'} kgf
                        </p>
                        <p className="adicional-info-content" style={{ margin: '4px 0' }}>
                          <strong>Mão direita:</strong> {resultadoPreensao.melhorDireita ?? '-'} kgf
                          {' | '}
                          <strong>Mão esquerda:</strong> {resultadoPreensao.melhorEsquerda ?? '-'} kgf
                        </p>
                        {descreverAssimetria(resultadoPreensao) && (
                          <p className="adicional-info-content" style={{ margin: '4px 0' }}>
                            <strong>Simetria bilateral:</strong> {descreverAssimetria(resultadoPreensao)}
                          </p>
                        )}
                        {textoClassificacaoPreensao(encontrarFaixa(forcaApreensaoManual, faixasSelecionadas)?.name) && (
                          <p className="adicional-info-content" style={{ margin: '10px 0 0 0' }}>
                            {textoClassificacaoPreensao(encontrarFaixa(forcaApreensaoManual, faixasSelecionadas)?.name).resultado}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                )}
                {(metodo === 'ForcaGeral') &&(
                  <div className="resultado-vo2-container pad-top-10">
                    {resultado && (
                      <div>
                        <div style={{ marginTop: 5 }}>
                          <GraficoBarraComIndicador valor={resultado.totalPontos} faixas={tabelaSomatoria1RM} />
                          <div className='titulo-resultado-1rm'>
                            Total de pontos: {resultado.totalPontos} - {" "}
                            Condicionamento: <strong>{resultado.classificacao}</strong>
                          </div>
                        </div>
                        <table className='tabela-rm-dados' border="1" cellPadding="6" style={{ borderCollapse: "collapse", width: "100%" }}>
                          <thead>
                            <tr>
                              <th>Exercício</th>
                              <th>1RM (kg)</th>
                              <th>Força relativa</th>
                              <th>Pontos</th>
                            </tr>
                          </thead>
                          <tbody>
                            {resultado.resultadosExercicios.map((ex) => (
                              <tr key={ex.id}>
                                <td>{ex.nome}</td>
                                <td>{formatarNumero(ex.oneRM, 1)}</td>
                                <td>{formatarNumero(ex.forcaRelativa, 2)}</td>
                                <td>{ex.pontos}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                  </div>
                )}
            </div>
          </div>
        )}

        <Modal
          isOpen={isNextModal}
          onRequestClose={closeNextModal}
          contentLabel="Confirmacao"
          className="modal-next"
          overlayClassName="popup-overlay"
          >
            <p className="popupNext-h1">Teste finalizado!</p>
            <p className="popupNext-h2">Qual será a próxima etapa?</p>
            <div className="sub-pagination-buttons sub-pagination-buttons-coluna">
              <button className="next-prev-button" type="button" onClick={iniciarNovoTeste}>
                Realizar outro teste neuromuscular
              </button>
              <button className="next-prev-button" type="button" onClick={() => setActiveTab('Anamnese')}>
                Voltar ao início
              </button>
              <button className="next-prev-button" type="button" onClick={finalizarAvaliacao}>
                Finalizar a avaliação
              </button>
            </div>
        </Modal>

        <div className="pagination-footer">
          <div className="sub-pagination-footer">
            <div className="sub-pagination-buttons">
              {etapa > 0 && (
                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                  Voltar
                </button>
              )}
              {etapa < 3 ? (
                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                  Avançar
                </button>
              ) : (
              <button className="next-prev-button" type="button" onClick={handleNeuromuscularRegister}>Registrar</button>
              )}
            </div>
            <div className="progress-container">
              <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
            </div>
          </div>
          <div className="info-box-container" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
            <div className="info-button">
              <HelpCircle size={20} />
              Mais informações
            </div>
            {showInfo && (
              <div className="info-box-content">
                <p className="">
                  Avaliação neromuscular
                  <br/><br/>
                  A avaliação neuromuscular analisa a capacidade do sistema muscular de produzir força, potência, resistência e eficiência de movimento. Por meio de testes específicos, é possível identificar níveis de desempenho muscular, equilíbrio entre grupos musculares, capacidades funcionais e possíveis limitações físicas.
                  <br/><br/>
                  Essa avaliação é fundamental para a prescrição segura e individualizada do treinamento, auxiliando no desenvolvimento da força, prevenção de lesões, melhora da performance e acompanhamento da evolução física de forma objetiva.
                </p>
              </div>
            )}
          </div>
        </div>

      </div>

    </div>
  );
}

export default AvaliacaoNeuromuscular;
